export default {
    yes: "Oui",
    no: "Non",
    ok: "Ok",
    cancel: "Annuler",
    validate: "Valider",
    requiredMessage: "Veuillez saisir une valeur",
    outputTextNoValue: " ",
    numericMessage: "Please enter a numeric value",
    decimalMessage: "Please enter a decimal value",
    dateMessage: "Veuillez saisir une date valide",
    eMailMessage: "Please enter valid email",
    tableColumnsSelectedText: "Colonnes sélectionnées",
    tableAllColumnsSelectedText: "Tous",
    tableNoDataText: "Pas de données",
    dialogTitleAttention: "Attention !",
    dialogTitleInformation: "Information !",
    preloaderText: "Chargement...",
    preventPasteHint:
        "Veuillez saisir les données manuellement – l’option de collage n’est pas autorisée.",
    flowCancelFlowMessage: "Tous vos progrès seront perdus. Êtes-vous sûr de vouloir quitter ?",
    serverErrorTitle: "Attention !",
    serverErrorMessage: "L’application a rencontré un problème.",

    fileUploadPlaceholder: "télécharger un fichier",
    fileUploadTitle: "Veuillez glisser-déposer",

    cancelFlowFailure: "L’annulation de l’activité a échoué !",
    requestFlowFailure: "La demande de l’activité a échoué !",
    endFlowError: "Erreur dans le traitement de l’activité !",
    stepPostFailure: "Le traitement de l’étape a échoué !",
    flowFailure: "Le chargement du processus métier a échoué !",
    stepDataFailure: "Le chargement des données de l'étape a échoué !",
    defaultValidationMessage:
        "Les valeurs saisies ne sont pas valides. Veuillez modifier votre saisie.",

    modalAcceptLabel: "OK",
    modalCloseLabel: "Annuler",
    errorGroupLabel: "Messages bloquants",
    successGroupLabel: "Succès",
    warningGroupLabel: "Warnings",
    infoGroupLabel: "Information",
    neutralGroupLabel: "Message",
    collapsedHintGroupLabel: "Afficher les détails",

    renderErrorMessage: "Il y a eu un problème.",

    error: "Erreur",
    warning: "Attention",

    unsavedChanges:
        "Les modifications que vous avez apportées ne seront peut-être pas enregistrées.",
    enterValidInfo: "Veuillez saisir des informations valides",
    completeFlowFailure: "Le processus métier n’a pas pu être complété !",
    stepConfigFailure: "Impossible de charger la configuration de l'étape ui",

    googleMapErrorMessage: "L'emplacement n'est pas identifié",
    beforeExitFlowMessage:
        "En poursuivant, toutes les données déjà saisies seront sauvegardées et vous pourrez y accéder plus tard. Êtes-vous certain de vouloir quitter la saisie ?"
};
